import {
  PAYMENTS_SUCCESS,
} from '../constants/actions';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENTS_SUCCESS:
      return {
        ...state,
        data: action.data,
      };

    default:
      return { ...state };
  }
};
